import React, { useState, useEffect } from "react"; // ✅ add useEffect here
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate, useLocation } from "react-router-dom";
import RosterActions from "../HospitalRoaster/RosterActions";
import { downloadPDFs } from "../HospitalRoaster/utils/rosterUtils";
import { exportToPDF, generatePDFBlob } from "../HospitalRoaster/utils/pdfUtils";
import DoctorsAttendance from "../HospitalRoaster/DoctorsAttendance";


const AttendanceSelector = () => {
  const [selection, setSelection] = useState("");
  const navigate = useNavigate();

  const handleSelect = (e) => {
    const value = e.target.value;
    setSelection(value);

    // 👇 Navigate to DoctorAttendanceSheet and pass selected value
    navigate("/attendance-sheet", { state: { selection: value } });
  };
}



const DoctorAttendanceSheet = () => {
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");
  const [attendanceData, setAttendanceData] = useState(null);
  const [numDays, setNumDays] = useState(0);
  const [loading, setLoading] = useState(false);

  const location = useLocation();

    const navigate = useNavigate();
  
    // 🔒 Redirect if not logged in
    useEffect(() => {
      const isAuthed = sessionStorage.getItem("staff_portal_authed");
      if (!isAuthed) {
        Swal.fire({
          icon: "warning",
          title: "Access Denied",
          text: "Please log in to continue.",
          confirmButtonText: "Go to Login",
          confirmButtonColor: "#007bff",
        }).then(() => {
          navigate("/attendance-login", { replace: true });
        });
      }
    }, [navigate]);

    // 🔐 Access control state
  const [authorized, setAuthorized] = useState(false);
  const [passkey, setPasskey] = useState("");
  const [showInput, setShowInput] = useState(true);
  const [showAttendance, setShowAttendance] = useState(false);
  const correctKey = "R!C@2025"; // ✅ static passkey


const handleAccess = () => {
  if (passkey === correctKey) {
    Swal.fire({
      icon: "success",
      title: "Access Granted",
      text: "Opening attendance view...",
      timer: 1000,
      showConfirmButton: false,
    });
    setTimeout(() => {
      setAuthorized(true);
      setShowInput(false);
    }, 900);
  } else {
    Swal.fire("❌ Invalid Passkey", "Please try again.", "error");
  }
};



  const statusColors = {
    P: "#19c776ff",
    A: "#d63d4dff",
    L: "#0d94afff",
    "D/O": "#a7a7eeff",
  };

  const handleViewSheet = async () => {
    if (!selectedCategory || !selectedMonth) {
      Swal.fire("⚠️ Missing Info", "Please select both month and category", "warning");
      return;
    }

    setLoading(true);
    try {
      const department = "doctorsattendance";
      const url = `https://ricgop.online/backend/staff/api/view-roster.php?department=${department}&category=${selectedCategory}&month=${encodeURIComponent(
        selectedMonth
      )}`;
      const res = await axios.get(url);

      if (res.data?.success && res.data?.data) {
        const roster = Object.values(res.data.data)[0];
        if (!roster || !roster.staffs) {
          setAttendanceData(null);
          Swal.fire("ℹ️ No Data", "No attendance found for this selection.", "info");
        } else {
          setAttendanceData(roster.staffs);
          setNumDays(roster.num_days);
        }
      } else {
        Swal.fire("❌ Error", "No attendance data found", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("❌ Error", "Unable to load attendance sheet", "error");
    } finally {
      setLoading(false);
    }
  };

  

  return (
    <div
      className="min-vh-100 d-flex flex-column align-items-center"
      style={{
        background: "linear-gradient(135deg, #e0f7fa, #e3f2fd, #f3e5f5)",
        padding: "60px 0",
      }}
    >
      <div
        className="p-5 shadow-lg rounded-4 border bg-white"
        style={{
          width: "95%",
          maxWidth: "1300px",
          backdropFilter: "blur(12px)",
          background: "rgba(255,255,255,0.95)",
        }}
      >
        {/* Header + Back Button */}
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h2 className="fw-bold text-primary mb-0">
            📊 Doctors Attendance Sheet Viewer
          </h2>
          <button
            onClick={() => navigate("/mark-attendance")}
            className="btn btn-outline-primary rounded-pill fw-semibold"
          >
            ⬅️ Back to Mark Attendance
          </button>
        </div>

        {/* Filter Section */}
        <div className="row g-3 align-items-end mb-4">
          <div className="col-md-5">
            <label className="form-label fw-semibold text-secondary">🏥 Category</label>
            <select
              className="form-select shadow-sm rounded-3"
              value={selectedCategory}
              onChange={(e) => setSelectedCategory(e.target.value)}
            >
              <option value="">-- Select Category --</option>
              <option value="AP">AP – Assistant Professor</option>
              <option value="SR">SR – Senior Registrar</option>
              <option value="MO">MO – Medical Officer</option>
              <option value="PG">PG – Post Graduate</option>
            </select>
          </div>

        <div className="col-md-5">
  <label className="form-label fw-semibold text-secondary">📅 Month</label>
<select
  className="form-select shadow-sm rounded-3"
  value={selectedMonth}
  onChange={(e) => setSelectedMonth(e.target.value)}
>
  <option value="">-- Select Month --</option>
  {Array.from({ length: 15 }, (_, i) => {
    const d = new Date();
    d.setDate(1); // prevent date rollover issues
    d.setMonth(d.getMonth() - 12 + i); // 12 months back + current + 3 future
    const label = d.toLocaleString("default", {
      month: "long",
      year: "numeric",
    });
    return (
      <option key={i} value={label}>
        {label}
      </option>
    );
  })}
</select>

</div>


          <div className="col-md-2 text-center">
            <button
              className="btn btn-primary w-100 shadow-sm fw-semibold"
              onClick={handleViewSheet}
              disabled={loading}
            >
              {loading ? "Loading..." : "📄 View"}
            </button>
          </div>
        </div>
<button
  className="btn btn-primary shadow-sm"
  onClick={async () => {
    if (!attendanceData)
      return Swal.fire("⚠️", "No data to export", "warning");

    try {
      Swal.fire({
        title: "Generating PDF...",
        text: "Please wait while the attendance report is being prepared.",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const staff = Object.keys(attendanceData);
      const days = attendanceData;

      const blob = await generatePDFBlob({
        language: "en",
        staff,
        days,
        numDays,
        month: selectedMonth,
        selectedCategory,
      });

      Swal.close();

      // ✅ Trigger browser download safely
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      a.download = `Doctors_Attendance_${selectedMonth}.pdf`;

      document.body.appendChild(a);
      a.click();

      // ⏳ give time before revoking
      setTimeout(() => {
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      }, 2000);

      Swal.fire({
        icon: "success",
        title: "Download Ready!",
        text: "The PDF has been successfully generated.",
        timer: 2000,
        showConfirmButton: false,
      });

    } catch (err) {
      console.error("PDF export error:", err);
      Swal.fire("❌ Error", "Failed to generate PDF. Please try again.", "error");
    }
  }}
>
  📥 Download PDFs
</button>




{/* Attendance Table */}
{attendanceData && (
  <div className="table-wrapper mx-auto mt-4">
    <table
      id="attendanceTable"
      className="table table-bordered text-center align-middle shadow-sm rounded-3"
    >
      <thead className="bg-primary text-white sticky-top">
        <tr>
          <th>Doctor Name</th>
          {Array.from({ length: numDays }, (_, i) => (
            <th key={i}>{i + 1}</th>
          ))}
          <th>Summary</th>
        </tr>
      </thead>
      <tbody>
        {Object.entries(attendanceData).map(([name, days], idx) => {
          const values = Object.values(days);
          const totalP = values.filter((v) => v === "P").length;
          const totalA = values.filter((v) => v === "A").length;
          const totalL = values.filter((v) => v === "L").length;
          const totalDays = values.filter((v) => v !== "D/O").length || 1;
          const percent = ((totalP / totalDays) * 100).toFixed(1);
          const color =
            percent >= 80
              ? "text-success"
              : percent >= 60
              ? "text-warning"
              : "text-danger";

          return (
            <tr key={idx}>
              <td className="fw-semibold text-start">{name}</td>
              {Array.from({ length: numDays }, (_, i) => {
                const status = days[i + 1] || "";
                const bg = statusColors[status] || "#f8f9fa";
                return (
                  <td
                    key={i}
                    style={{
                      backgroundColor: bg,
                      color: "#fff",
                      fontWeight: "600",
                    }}
                  >
                    {status || ""}
                  </td>
                );
              })}
              <td className={`fw-bold ${color}`}>
                P:{totalP} | A:{totalA} | L:{totalL} ({percent}%)
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
)}


{/* Show message if no attendance data */}
{!attendanceData && (
  <div className="text-center text-muted mt-4">
    <p>Select a category and month to view attendance sheet.</p>
  </div>
)}

{/* 🔐 Secure Private Attendance Section */}
<div className="text-center mt-5 p-4 border rounded-4 bg-light shadow-sm">
  {/* Passkey input */}
  {!authorized && showInput && (
    <form
      className="d-flex flex-column align-items-center"
      onSubmit={(e) => {
        e.preventDefault();
        handleAccess();
      }}
    >
      <h5 className="fw-semibold mb-3">🔐 Enter Passkey to Access Full Control</h5>
      <input
        type="password"
        className="form-control rounded-3 shadow-sm text-center"
        placeholder="Enter passkey..."
        value={passkey}
        onChange={(e) => setPasskey(e.target.value)}
        style={{
          maxWidth: "240px",
          border: "2px solid #007bff",
          fontWeight: "500",
        }}
      />
      <small className="text-muted mt-2">
        Press <strong>Enter</strong> to unlock
      </small>
    </form>
  )}

  {/* ✅ Once authorized — show fullscreen professional modal */}
  {authorized && (
    <div
    className="attendance-overlay"
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      background: "rgba(0,0,0,0.4)", // subtle dark overlay
      backdropFilter: "blur(10px)",
      zIndex: 9999,
      display: "flex",
      justifyContent: "center", // horizontally center
      alignItems: "center",     // vertically center
      padding: "20px",
    }}
  >
      <div
      style={{
        width: "100%",
        maxWidth: "1400px",
        height: "90%",
        background: "white",
        borderRadius: "12px",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        boxShadow: "0 8px 24px rgba(0,0,0,0.3)",
        position: "relative",
      }}
    >
      {/* Header */}
           <div
        className="d-flex justify-content-between align-items-center px-4 py-3 shadow-sm"
        style={{
          background: "#f8f9fa",
          borderBottom: "1px solid rgba(0,0,0,0.1)",
        }}
      >
        <h4 className="fw-bold text-primary mb-0">👩‍⚕️ Doctors Attendance</h4>
        <button
          type="button"
          onClick={() => {
            setAuthorized(false);
            setShowInput(true);
            setPasskey("");
          }}
          className="btn btn-outline-danger rounded-pill fw-semibold px-3"
        >
          ✖ Close
        </button>
      </div>

      {/* Scrollable Fullscreen Body */}
      <div
        className="flex-grow-1 overflow-auto w-100 p-4"
        style={{
          flex: 1,
          overflowY: "auto",
          padding: "20px",
          background: "#ffffff",
        }}
      >
        <div className="container-fluid">
          <DoctorsAttendance />
        </div>
      </div>
    </div>
    </div>
  )}

  {/* Smooth fade animation */}
  <style>{`
    @keyframes fadeIn {
      from { opacity: 0; transform: scale(0.98); }
      to { opacity: 1; transform: scale(1); }
    }
    .attendance-overlay::-webkit-scrollbar {
      width: 10px;
    }
    .attendance-overlay::-webkit-scrollbar-thumb {
      background: rgba(0,0,0,0.2);
      border-radius: 10px;
    }
  `}</style>
</div>




        {/* Styles */}
        <style>{`
          .table-wrapper {
            max-width: 1300px;
            overflow-x: auto;
            margin: 0 auto;
          }
          .table {
            border-radius: 12px;
            overflow: hidden;
            font-size: 13px;
          }
          .table th, .table td {
            vertical-align: middle;
            padding: 6px 8px;
          }
          .table thead th {
            position: sticky;
            top: 0;
            background-color: #007bff !important;
            color: white !important;
            z-index: 2;
          }
          .btn-primary {
            background: linear-gradient(90deg, #007bff, #00b4d8);
            border: none;
          }
          .btn-primary:hover {
            background: linear-gradient(90deg, #0056b3, #0096c7);
            transform: translateY(-2px);
          }
          .btn-outline-primary {
            border: 2px solid #007bff;
            color: #007bff;
            background: #fff;
            transition: all 0.3s ease;
          }
          .btn-outline-primary:hover {
            background: #007bff;
            color: #fff;
          }
        `}</style>
      </div>
    </div>
  );
};

export default DoctorAttendanceSheet;
